import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { cn } from '@/lib/utils';
import { PrimeTimeMetric, ConversionMetric } from '../hooks/types/primeTimesTypes';

type PrimeTimesMode = 'general' | 'result';

interface PrimeTimesTabNavigationProps {
  mode: PrimeTimesMode;
  activeMetric: PrimeTimeMetric | ConversionMetric;
  onMetricChange: (metric: PrimeTimeMetric | ConversionMetric) => void;
}

export function PrimeTimesTabNavigation({ 
  mode, 
  activeMetric, 
  onMetricChange 
}: PrimeTimesTabNavigationProps) {
  useLanguage();
  
  // Tabs dinâmicas conforme o modo
  const generalTabs: Array<{ id: PrimeTimeMetric; label: string }> = [
    { id: 'plays', label: translateInterfaceText("Plays Únicos") },
    { id: 'views', label: translateInterfaceText("Visualizações Únicas") }
  ];
  
  const resultTabs: Array<{ id: ConversionMetric; label: string }> = [
    { id: 'conversions', label: translateInterfaceText("Conversões") },
    { id: 'conversionRate', label: translateInterfaceText("Taxa de Conversão") },
    { id: 'revenue', label: translateInterfaceText("Receita") }
  ];
  
  const tabs = mode === 'general' ? generalTabs : resultTabs;

  return (
    <div role="tablist" className="inline-flex gap-1.5 md:gap-2" aria-label={translateInterfaceText("Métricas")}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={activeMetric === tab.id}
          onClick={() => {
            onMetricChange(tab.id);
            console.log('peaks_tab_changed', { metric: tab.id });
          }}
          className={cn(
            "h-[26px] md:h-[30px] min-w-0 px-2.5 md:px-3 py-1 rounded-md md:rounded-lg text-[11px] md:text-xs font-medium transition-all duration-150 ease-out",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            activeMetric === tab.id
              ? 'bg-[#2D6CF6] text-white'
              : 'bg-transparent text-[#2D6CF6] border border-[#93C5FD] hover:bg-[#F3F7FF]'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
